/* =========================================================================
   wf-track.js — mesure des landing pages Wild Fallow
   -------------------------------------------------------------------------
   Répond à : « à quel % la page est vue, jusqu'où les gens vont, où ça drop ».

   Trois sorties, toutes optionnelles et indépendantes :
     1. window.WF_TRACK_ENDPOINT  → notre Worker Cloudflare (sendBeacon)
     2. window.dataLayer          → GTM / GA4, si GTM est présent
     3. window.fbq                → Meta, en trackCustom, si le pixel est présent
   Si rien n'est branché, le script ne fait aucune requête réseau et ne casse rien.

   Debug : ajouter ?wfdebug=1 à l'URL → badge en bas d'écran + console.table.

   Ni email ni nom ni IP ne sont collectés ici (c'est le Worker qui hache l'IP
   côté serveur). `cid` est un identifiant aléatoire posé dans localStorage,
   effaçable par le visiteur.

   ⚠️ EN REVANCHE, le quiz produit des réponses sur le tabac, l'alcool, le
   sommeil et le stress, et un niveau de vieillissement inféré. Aux États-Unis
   ce sont des « consumer health data » (Washington My Health My Data Act,
   Nevada SB 370, et les lois d'État qui classent la santé en donnée sensible).
   Les envoyer à un pixel publicitaire est ce que la FTC a sanctionné chez
   GoodRx et BetterHelp, et ce que les Business Tools Terms de Meta
   interdisent — avec désactivation du pixel à la clé.

   D'où la règle appliquée plus bas : ces événements ne sortent QUE vers notre
   propre endpoint. Ni `fbq`, ni `dataLayer`. Voir SANTE et PUB_PROPS.
   ========================================================================= */
(function (w, d) {
  'use strict';
  if (w.WF) return;                       // déjà chargé
  var DNT = (navigator.doNotTrack === '1' || w.doNotTrack === '1');

  /* ---------- identité ------------------------------------------------- */
  function rnd() {
    return (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
  }
  function store(k, v, session) {
    try { (session ? sessionStorage : localStorage).setItem(k, v); } catch (e) {}
  }
  function read(k, session) {
    try { return (session ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; }
  }
  var cid = read('wf_cid') || rnd(); store('wf_cid', cid);
  var sid = read('wf_sid', true) || rnd(); store('wf_sid', sid, true);

  /* ---------- contexte de la page -------------------------------------- */
  var qs = new URLSearchParams(location.search);
  var UTM = {
    source:   qs.get('utm_source')   || '',
    medium:   qs.get('utm_medium')   || '',
    campaign: qs.get('utm_campaign') || '',
    content:  qs.get('utm_content')  || '',
    term:     qs.get('utm_term')     || ''
  };
  // Les UTM n'existent que sur la première page du funnel : on les mémorise
  // pour la session, sinon le passage listicle → sales perd la source.
  if (UTM.source) store('wf_utm', JSON.stringify(UTM), true);
  else { try { UTM = JSON.parse(read('wf_utm', true)) || UTM; } catch (e) {} }

  // Nom de page : <body data-page="..."> sinon le nom de fichier.
  var PAGE = (d.body && d.body.dataset.page) ||
             (location.pathname.split('/').pop() || 'index').replace(/\.html?$/, '');

  var DEBUG = qs.get('wfdebug') === '1';
  var t0 = Date.now();

  /* ---------- file d'envoi --------------------------------------------- */
  var queue = [], flushTimer = null, sent = 0;

  function payload(ev, props) {
    return {
      cid: cid, sid: sid, page: PAGE, event: ev, props: props || {},
      ts: Date.now(), ref: d.referrer || '', utm: UTM,
      vw: w.innerWidth, dpr: w.devicePixelRatio || 1
    };
  }

  function flush(sync) {
    if (!queue.length) return;
    var batch = queue.splice(0, queue.length);
    var url = w.WF_TRACK_ENDPOINT;
    if (!url) return;                        // pas d'endpoint → on jette, sans erreur
    var body = JSON.stringify(batch);
    try {
      if (sync && navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      } else if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      } else {
        fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }).catch(function () {});
      }
      sent += batch.length;
    } catch (e) {}
  }

  /* ---------- cloison entre notre mesure et les régies ------------------ */
  /* Ces événements portent, ou peuvent porter, une donnée de santé : réponse
     sur le tabac, l'alcool, le sommeil, le stress, ou un niveau de
     vieillissement inféré. Ils ne quittent jamais notre propre endpoint. */
  var SANTE = {
    quiz_answer: 1, quiz_score: 1, quiz_gate: 1, quiz_gate_view: 1,
    quiz_profile: 1, quiz_projection: 1
  };
  /* Pour tous les autres, on ne laisse passer vers les régies qu'une poignée de
     champs non identifiants. Une liste blanche, pas une liste noire : un
     nouveau champ ajouté au quiz ne doit pas fuiter par défaut. */
  var PUB_PROPS = ['depth', 's', 'id', 'pos', 'plan', 'n', 'max_scroll', 'dur'];

  /* Sur la page du quiz on va plus loin : même un `section_view` dit laquelle
     des douze questions a été atteinte, et leurs identifiants s'appellent
     q-smoke, q-alcohol, q-sleep, q-stress. Seuls quatre événements, tous sans
     propriété, atteignent les régies — assez pour optimiser une campagne sur la
     complétion du quiz, rien de plus. */
  var PAGE_SENSIBLE = (PAGE === 'quiz');
  var PUB_QUIZ = { page_view: 1, cta_click: 1, quiz_start: 1, quiz_complete: 1 };

  function propsPub(props) {
    var o = {};
    if (!props) return o;
    for (var i = 0; i < PUB_PROPS.length; i++) {
      var k = PUB_PROPS[i];
      if (props[k] !== undefined && typeof props[k] !== 'object') o[k] = props[k];
    }
    return o;
  }

  function track(ev, props) {
    if (DNT) return;
    var p = payload(ev, props);
    queue.push(p);

    var versRegies = !SANTE[ev] && (!PAGE_SENSIBLE || PUB_QUIZ[ev]);
    if (versRegies) {
      var pub = PAGE_SENSIBLE ? {} : propsPub(props);
      if (w.dataLayer && w.dataLayer.push) {
        w.dataLayer.push(Object.assign({ event: 'wf_' + ev, wf_page: PAGE }, pub));
      }
      if (typeof w.fbq === 'function') {
        try { w.fbq('trackCustom', 'wf_' + ev, Object.assign({ page: PAGE }, pub)); } catch (e) {}
      }
    }
    if (DEBUG) { console.log('[wf]', ev, props || {}); badge(ev, props); }

    clearTimeout(flushTimer);
    flushTimer = setTimeout(flush, 2500);
    if (queue.length >= 12) flush();
  }

  /* ---------- profondeur de scroll ------------------------------------- */
  var maxDepth = 0, hit = {};
  var MARKS = [25, 50, 75, 90, 100];
  function depth() {
    var h = d.documentElement.scrollHeight - w.innerHeight;
    if (h <= 0) return 100;
    return Math.min(100, Math.round((w.scrollY / h) * 100));
  }
  function onScroll() {
    var p = depth();
    if (p > maxDepth) maxDepth = p;
    for (var i = 0; i < MARKS.length; i++) {
      var m = MARKS[i];
      if (maxDepth >= m && !hit[m]) { hit[m] = 1; track('scroll', { depth: m }); }
    }
  }

  /* ---------- sections vues -------------------------------------------- */
  var lastSection = '';
  function watchSections() {
    var els = d.querySelectorAll('[data-sec]');
    if (!els.length || !w.IntersectionObserver) return;
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var id = e.target.dataset.sec;
        lastSection = id;
        if (seen[id]) return;
        seen[id] = 1;
        track('section_view', { id: id });
      });
    }, { threshold: 0.4 });
    [].forEach.call(els, function (el) { io.observe(el); });
  }

  /* ---------- clics CTA ------------------------------------------------- */
  function watchCtas() {
    d.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('[data-cta]') : null;
      if (!el) return;
      track('cta_click', {
        id: el.dataset.cta,
        pos: el.dataset.ctaPos || String(Math.round(depth())),
        txt: (el.innerText || '').trim().slice(0, 40)
      });
    }, true);
  }

  /* ---------- paliers de temps ------------------------------------------ */
  var TIMES = [10, 30, 60, 120, 300];
  function watchTime() {
    TIMES.forEach(function (s) {
      setTimeout(function () {
        if (!d.hidden) track('time', { s: s });
      }, s * 1000);
    });
  }

  /* ---------- sortie ---------------------------------------------------- */
  function onExit() {
    track('exit', {
      max_scroll: maxDepth,
      last_section: lastSection,
      dur: Math.round((Date.now() - t0) / 1000)
    });
    flush(true);
  }

  /* ---------- badge de debug -------------------------------------------- */
  var bEl = null, bN = 0;
  function badge(ev, props) {
    if (!bEl) {
      bEl = d.createElement('div');
      bEl.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:99999;max-width:min(92vw,360px);' +
        'background:#121212;color:#EDE6DA;font:11px/1.45 ui-monospace,Menlo,monospace;' +
        'padding:8px 10px;border-radius:8px;opacity:.93;pointer-events:none;white-space:pre-wrap';
      d.body.appendChild(bEl);
    }
    bN++;
    bEl.textContent = '[wf-debug] ' + PAGE + ' — ' + bN + ' events\nscroll max ' + maxDepth + '%\n' +
      '→ ' + ev + ' ' + JSON.stringify(props || {}).slice(0, 120) +
      (w.WF_TRACK_ENDPOINT ? '' : '\n(aucun endpoint : rien n\'est envoyé)');
  }

  /* ---------- API publique ---------------------------------------------- */
  w.WF = {
    track: track,
    flush: flush,
    cid: cid,
    sid: sid,
    page: PAGE,
    depth: function () { return maxDepth; },
    /* Mémorise une réponse pour la repasser à la page suivante du funnel. */
    carry: function (k, v) { store('wf_' + k, v, true); },
    get: function (k) { return read('wf_' + k, true); }
  };

  /* ---------- démarrage -------------------------------------------------- */
  function start() {
    track('page_view', {
      t: d.title.slice(0, 80),
      h: d.documentElement.scrollHeight,
      vh: w.innerHeight
    });
    watchSections(); watchCtas(); watchTime();
    w.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    w.addEventListener('pagehide', onExit);
    d.addEventListener('visibilitychange', function () { if (d.hidden) { flush(true); } });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
